module.exports = __webpack_public_path__ + "img/5.14d6abb4.svg";